/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".time-zone-input[_ngcontent-%COMP%]{border:1px solid #ccc;width:94%;margin:9px;padding:2px 6px}\n/*# sourceMappingURL=shopperreport.component.css.map*/"];
export { styles as styles };
